<!--
 * @Description: 详情页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 07:28:56
 * @LastEditors: 山淑兰
-->
<template>
  <div class="details">
    <div class="loading" v-if="loading">
      <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
    </div>
    <div class="details-con">
      <div class="details-con-main">
        <template v-if="$i18n.locale === 'zh-CN'">
          <div class="details-cons">
            <div class="details-head">
              <div class="guest-headimg" @click="viewPhoto()">
                <img :src="this.dataList.photo || this.defaultHeadImg" alt />
              </div>
              <div class="guest-top">
                <div class="guest-intro">
                  <div class="guest-name">
                    <span v-html="nToBr(this.dataList.cnname)"></span>
                  </div>
                  <div class="host" v-html="nToBr(this.dataList.cncompany)"></div>
                </div>
              </div>
              <div class="guest-close" @click="closeGuest">
                <img src="../../../assets/h-close.png">
              </div>
            </div>
            <ul class="details-tab">
              <li :class="{'active':tabShow1}" @click="getIntro()"
                v-if="introStatus && this.dataList.cnintroduction != '' && this.dataList.cnintroduction != null">
                {{ $t('meeting.details.guestsIntroductionTitle') }}
              </li>
              <li :class="{'active':tabShow2}" @click="getdetails()" v-if="list.length>0&&isshowprogram==0">
                学术任务({{programCount}})</li>
            </ul>
            <div id="guestIntroduction-con" v-if="tabShow1">
              <p v-html="this.dataList.cnintroduction"></p>
            </div>
            <div class="details-main" v-if="tabShow2">
              <div v-show="show == 'tasks'" v-for="(item, index) in list" :key="index">
                <div class="details-main-head">
                  <van-cell :title="item[0].proDate" icon="calendar-o" class="details-main-head-date" />
                </div>
                <van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
                  <div class="meeting-list" v-if="i.url!=null">
                    <div class="meeting-left">
                      <van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">{{ i.roomName }}</van-cell>
                      <van-cell icon="orders-o" class="major-title" :class="{ _link: i.url }" v-if="i.roomTitle">{{ i.roomTitle }}</van-cell>
                      <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="nToBr(i.topic)"></span></van-cell>
                      <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{ i.roleName }}</van-cell>
                    </div>
                    <div class="meeting-icon">
                      <a :href="i.url" target="_top"><p><img src="../../../assets/creame3.png">观看直播</p></a>
                    </div>
                  </div>
                  <div class="meeting-list" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                    <div class="meeting-left">
                      <van-cell icon="location-o" class="major-title">{{ i.roomName }}</van-cell>
                      <van-cell icon="orders-o" class="major-title" v-if="i.roomTitle">{{ i.roomTitle }}</van-cell>
                      <van-cell icon="clock-o" class="major-title">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="nToBr(i.topic)"></span></van-cell>
                      <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{ i.roleName }}</van-cell>
                    </div>
                    <div class="meeting-icons"><img class="arrow" src="../../../assets/arrow-r.png"></div>
                  </div>
                </van-cell>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="details-cons">
            <div class="details-head">
              <div class="guest-headimg" @click="viewPhoto()">
                <img :src="this.dataList.photo || this.defaultHeadImg" alt />
              </div>
              <div class="guest-top">
                <div class="guest-intro">
                  <div class="guest-name">
                    <span v-html="this.dataList.enname!=null&&this.dataList.enname!=''?nToBr(this.dataList.enname):nToBr(this.dataList.cnname)"></span>
                  </div>
                  <div class="host" v-html="this.dataList.encompany!=null&&this.dataList.encompany!=''?nToBr(this.dataList.encompany):nToBr(this.dataList.cncompany)"></div>
                </div>
              </div>
              <div class="guest-close" @click="closeGuest">
                <img src="../../../assets/h-close.png">
              </div>
            </div>
            <ul class="details-tab">
              <li :class="{'active':tabShow1}" @click="getIntro()"
                v-if="introStatus && this.dataList.cnintroduction != '' && this.dataList.cnintroduction != null">
                {{ $t('meeting.details.guestsIntroductionTitle') }}
              </li>
              <li :class="{'active':tabShow2}" @click="getdetails()" v-if="list.length>0&&isshowprogram==0">
                Task({{programCount}})</li>
            </ul>
            <div id="guestIntroduction-con" v-if="tabShow1">
              <p v-html="this.dataList.enintroduction!=null&&this.dataList.enintroduction!=''?this.dataList.enintroduction:this.dataList.cnintroduction"></p>
            </div>
            <div class="details-main" v-if="tabShow2">
              <div v-show="show == 'tasks'" v-for="(item, index) in list" :key="index">
                <div class="details-main-head">
                  <van-cell :title="item[0].proDate" icon="calendar-o" class="details-main-head-date" />
                </div>
                <van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
                  <div class="meeting-list" v-if="i.url!=null">
                    <div class="meeting-left">
                      <van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">{{ i.roomEnName || i.roomName }}</van-cell>
                      <van-cell icon="orders-o" class="major-title" :class="{ _link: i.url }" v-if="i.roomEnTitle || i.roomTitle">{{ i.roomEnTitle || i.roomTitle }}</van-cell>
                      <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="i.entopic || i.topic"></span></van-cell>
                      <van-cell class="major-title" icon="user-o" v-if="i.roleEnName || i.roleName">{{ i.roleEnName || i.roleName }}</van-cell>
                    </div>
                    <div class="meeting-icon">
                      <a :href="i.url" target="_top"><p><img src="../../../assets/creame3.png">观看直播</p></a>
                    </div>
                  </div>
                  <div class="meeting-list" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                    <div class="meeting-left">
                      <van-cell icon="location-o" class="major-title">{{ i.roomEnName || i.roomName }}</van-cell>
                      <van-cell icon="orders-o" class="major-title" v-if="i.roomEnTitle || i.roomTitle">{{ i.roomEnTitle || i.roomTitle }}</van-cell>
                      <van-cell icon="clock-o" class="major-title">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="i.entopic || i.topic"></span></van-cell>
                      <van-cell class="major-title" icon="user-o" v-if="i.roleEnName || i.roleName">{{ i.roleEnName || i.roleName }}</van-cell>
                    </div>
                    <div class="meeting-icons"><img class="arrow" src="../../../assets/arrow-r.png"></div>
                  </div>
                </van-cell>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import defaultHeadImg from '../../../assets/defaultHeadImg.png'

export default {
  neme: 'details',
  props: ['exid','introStatus','isshowprogram','taskRoute'],
  data() {
    return {
      loading: false,
      show: 'tasks',
      defaultHeadImg,
      list: {},
      dataList: [],
      tabShow1: true,
      tabShow2: false,
      gusetShow: false,
      programCount: 0,
    }
  },
  created() {
    this.init()
    this.init1()
    if (this.introStatus) {
      this.tabShow1 = true
      this.tabShow2 = false
    } else {
      this.tabShow1 = false
      this.tabShow2 = true
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    showCon(index) {
      if (index == 'tasks') {
        this.show = 'tasks'
      } else {
        this.show = 'guestIntroduction'
      }
    },
    formatTime(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let endtime = Number(end)
      let date = new Date(endtime)
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
    formatDate(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let date = new Date(Number(end))
      let month = date.getMonth() + 1
      let day = date.getDate()
      return month + '-' + day
    },
    async init() {
      try {
        this.loading = true
        const { m } = this.$route.query
        const exid = this.exid
        const _params = { m, exid }
        const PopupData = await this.$http.initScheduleInfo({ m })
        this.$emit('searchDatas', PopupData.childens)
        const res = await this.$http.initGuestInfo(_params)
        this.dataList = res.expert
        if (this.dataList.cnintroduction) {
          this.dataList.cnintroduction = this.dataList.cnintroduction.replace(/\n/g, '<br>')
        }
        if (this.dataList.enintroduction) {
          this.dataList.enintroduction = this.dataList.enintroduction.replace(/\n/g, '<br>')
        }
        if( this.dataList.cnintroduction == '' || this.dataList.cnintroduction == null || !this.introStatus){
          this.tabShow1 = false
          this.tabShow2 = true
        }else{
          this.tabShow1 = true
          this.tabShow2 = false
        }
        let _list = []
        this.programCount = 0
        res.DateListEntity.map((item) => {
          let _k = []
          for (let i in item.programListEntity) {
            let _D = item.programListEntity[i]
            let { programList } = _D.programs
            for (let j in programList) {
              let _S = programList[j]
              programList[j] = {
                url: _S.programRoom.url,
                proDate: item.proDate,
                createdTime: this.formatDate(_S.programDate.prodate),
                startTime: _S.starttime,
                endTime: _S.endtime,
                total: item.ProgramCount,
                pohto: res.expert.photo,
                topic: _S.topic,
                roomName: _S.programRoom.roomname,
                roomTitle: _S.programRoom.roomtitle,
                roleName: _S.expertList[0].exrolemodel.rolename,
                dateid: _S.dateid,
                roomid: _S.roomid,
                entopic: _S.entopic,
                roomEnName: _S.programRoom.roomenname,
                roomEnTitle: _S.programRoom.roomentitle,
                roleEnName: _S.expertList[0].exrolemodel.roleenname,
              }
              _k.push(programList[j])
            }
          }
          this.programCount = Number(this.programCount) + Number(item.ProgramCount)
          _list.push(_k)
        })
        this.list = _list
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    async init1() {
      try {
        const { m } = this.$route.query
        this.m = m
        const _params = { m: m }
        const res = await this.$http.initMeetingInfo(_params)
        this.isshowprogram = res.isshowprogram
      } catch (error) {
        console.error(error)
      }
    },
    viewPhoto() {
      if (this.list.src) {
        ImagePreview({
          images: [this.list.src],
          startPosition: 0,
          onClose() {},
          showIndex: false,
          closeOnPopstate: true,
        })
      }
    },
    goMeeting(e,dateid,roomid){
      this.$emit("func",this.gusetShow)
      const { m, language } = this.$route.query
      const params = { m, roomid, dateid }
      if (language !== undefined) { params.language = language }
      if (this.taskRoute === 'accordion') {
        this.$router.push({ name: 'scheduleAccordion', query: params })
      } else {
        this.$router.push({ path: this.taskRoute || 'scheduleList', query: params })
      }
    },
    getIntro(){
      this.tabShow1 = true
      this.tabShow2 = false
    },
    getdetails(){
      this.tabShow1 = false
      this.tabShow2 = true
    },
    closeGuest(){
      this.$emit("func",this.gusetShow)
    },
    nToBr(str){
      if(str){
        return str.replace(/\\n/g,'<br/>');
      }else{
        return str
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.loading{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.clicked {
  border-bottom: 1px solid #6366f1;
}
.details {
  .details-con {
    .details-return{
      position: fixed;
      right: 0;
      bottom: 80px;
      width: 84px;
      height: 60px;
      z-index: 100;
      background: #3b82f6;
      border-radius: 30px 0 0 30px;
      text-align: center;
      line-height: 60px;
      color: #fff;
      img{ height: 100%; }
    }
    .details-con-main {
      color: #1e293b;
      font-size: 28px;
    }
    .details-cons{
      background: #fff;
      margin-bottom: 20px;
      #guestIntroduction-con {
        margin-top: 15px;
        padding: 10px 0;
        > h4 {
          font-size: 26px;
          border-bottom: 1px solid #e2e8f0;
          padding: 16px 20px;
          background: #3b82f6;
          border-radius: 12px 12px 0 0;
          color: #fff;
          margin-bottom: 10px;
        }
        > p{ padding: 0 20px; }
      }
    }
    .details-head {
      position: relative;
      background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 40%, #1e5fa8 100%);
      display: flex;
      align-items: center;
      padding: 30px 24px;
      color: #fff;
      .guest-headimg {
        text-align: center;
        margin-right: 24px;
        width: 130px;
        height: 130px;
        min-width: 130px;
        border-radius: 50%;
        border: 3px solid rgba(255,255,255,0.35);
        box-shadow: 0 6px 24px rgba(0,0,0,0.25);
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          display: block;
        }
      }
      .guest-top{ flex: 1; min-width: 0; }
      .guest-intro {
        display: flex;
        flex-direction: column;
        gap: 12px;
        .guest-name {
          font-size: 34px;
          font-weight: 600;
          line-height: 1.3;
          text-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }
        .host {
          font-size: 26px;
          opacity: 0.9;
          line-height: 1.5;
        }
      }
      .guest-close{
        position: absolute;
        right: 18px;
        top: 18px;
        width: 44px;
        height: 44px;
        background: rgba(255,255,255,0.2);
        backdrop-filter: blur(4px);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:active { background: rgba(255,255,255,0.35); }
        img{
          display: block;
          width: 26px;
          height: 26px;
          filter: brightness(0) invert(1);
        }
      }
    }
    .details-tab{
      margin: 30px 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e2e8f0;
      padding-bottom: 10px;
      li{ padding: 0 30px; }
      li.active{
        position: relative;
        color: #3b82f6;
      }
      li.active:after{
        position: absolute;
        display: block;
        content: '';
        height: 4px;
        left: 40px;
        right: 40px;
        bottom: -10px;
        background: #3b82f6;
      }
    }
    .details-title {
      margin: 20px 10px;
      font-size: 28px;
      color: #1e293b;
      span {
        display: inline-block;
        margin: 0px 18px;
        line-height: 60px;
        height: 60px;
      }
      & > div {
        height: 30%;
        font-size: 28px;
        .synopsis {
          .synopsis-tit {
            height: 60px;
            line-height: 60px;
            background: #e2e8f0;
            padding-left: 10px;
          }
        }
        .van-icon { color: #fff; }
      }
    }
    .details-main {
      > div {
        background: #fff;
        margin-bottom: 24px;
        border-bottom: 1px solid #e2e8f0;
      }
      .meeting-list{
        display: flex;
        margin-bottom: 10px;
        padding: 12px 20px 12px 22px;
        position: relative;
        border-left: 4px solid #3b82f6;
        background: #f8fafc;
        border-radius: 0 8px 8px 0;
        .meeting-left{ flex: 1; min-width: 0; }
        .meeting-icon{
          position: absolute;
          right: 0;
          top: 20px;
          z-index: 10;
          width: 140px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          background: linear-gradient(135deg, #3b82f6, #6366f1);
          padding: 8px 0;
          border-radius: 50px 0 0 50px;
          a{ color: #fff; display: block; text-align: center; }
          img{ width: 26px; vertical-align: -4px; }
          p{ font-size: 12px; }
        }
        .meeting-icons{
          width: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          a{ color: #1e293b; display: block; text-align: center; }
          img{ width: 90px; }
          img.arrow{ width: 90%; }
        }
      }
      .details-main-head {
        display: flex;
        .details-main-head-date {
          color: #3b82f6;
          padding: 0px 0px 0px 20px;
          font-size: 28px;
          font-weight: 600;
          & > .van-icon {
            font-size: 36px;
            line-height: 40px;
          }
          &:after { border: none; }
          span { line-height: 40px; }
        }
        .van-cell{
          background: none;
          color: #e6a23c;
        }
      }
      .details-main-con {
        position: relative;
        color: #1e293b;
        .major-title {
          padding: 8px 0;
          font-size: 26px;
          color: #1e293b;
          line-height: 36px;
          > i {
            width: 36px;
            font-size: 36px;
            line-height: 36px;
            color: #3b82f6;
          }
          > div { color: #1e293b; }
          &:after { border: 0px; }
        }
        .major-titles {
          padding: 8px 140px 8px 0;
          font-size: 26px;
          color: #1e293b;
          line-height: 36px;
          > i {
            width: 36px;
            font-size: 36px;
            line-height: 36px;
            color: #3b82f6;
          }
          > div { color: #1e293b; }
          &:after { border: 0px; }
        }
      }
      .details-main-con.van-cell{ padding: 0; }
      #guestIntroduction-con {
        min-height: 300px;
        margin-top: 20px;
        > h4 {
          font-size: 30px;
          padding-left: 20px;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #e2e8f0;
          padding: 16px 0px;
          display: flex;
          background: #3b82f6;
          border-radius: 12px 12px 0 0;
        }
        > p {
          width: 90%;
          margin: 0 auto;
          padding: 20px 0;
          line-height: 54px;
        }
      }
    }
  }
  ._link {
    > div { color: #3b82f6 !important; }
  }
}
</style>
